import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { SelectValue } from 'antd/lib/select';

import { Group } from 'store/admin/usergroups/types';
import { StyledSelect, StyledSelectWithLabel, StyledLabel } from './styles';

interface SelectUserGroupsProps {
  name: string;
  onChange: (value: SelectValue) => void;
  value?: string[] | null;
  userGroups: Group[];
}

const { Option } = Select;

export const FormikSelectUserGroups: FC<SelectUserGroupsProps> = ({ name, value = [], onChange, userGroups }) => {
  const { t } = useTranslation();

  return (
    <StyledSelectWithLabel>
      <StyledLabel>{t('infoFields.userGroups')}</StyledLabel>
      <Field as={StyledSelect} name={name} style={{ width: '100%' }} defaultValue={value} onChange={onChange}>
        {userGroups.map((group) => (
          <Option key={`${group.uid}`} value={group.uid}>
            {group.name}
            {group.enabled ? '' : ` ${t('group.disabled')}`}
          </Option>
        ))}
      </Field>
    </StyledSelectWithLabel>
  );
};
